export default {
  title: 'Horário de funcionamento',
  headers: {
    edit_time: 'Editar hora',
    create_time: 'Criar hora',
  },
  labels: {
    select_all: 'Selecionar tudo',
    timezone: 'Fuso horário',
  },
  fields: {
    selected_days: {
      label: 'Dias selecionados',
    },
    opening_time: {
      label: 'Hora de abertura',
    },
    closing_time: {
      label: 'Hora de fecho',
    },
  },
  columns: {
    days: 'Dias',
    time: 'Hora',
  },
  buttons: {
    add_opening_time: 'Adicionar horário de abertura',
    add: 'Adicionar',
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Fechar',
    delete: 'Eliminar',
    sync_from_online_shop: 'Sincronizar da Loja Online',
  },
  projects: {
    online_shop: 'Loja Online',
    reservations: 'Reservas',
    storefront: 'Loja',
    not_set_up: '{{project}} (não configurado para esta localização)',
  },
  feedback: {
    missing_info: 'Informação em falta',
  },
  toasts: {
    saving_success: 'Guardado com sucesso',
    saving_error: 'Falha ao guardar. Por favor, reveja a informação e tente novamente.',
    sync_success: 'Sincronizado com sucesso',
    sync_error: 'Falha ao sincronizar o horário de funcionamento da loja online. Por favor, tente novamente.',
    hours_required: 'O horário de funcionamento é obrigatório. Edite o horário existente',
    not_copied: {
      reservations: {
        not_set_up:
          'As reservas não foram atualizadas: as reservas ainda não estão configuradas para esta localização. O separador Reservas explica o motivo.',
        not_matched:
          'As reservas não foram atualizadas: o horário {{time}} não existe lá. Verifique os horários no separador Reservas.',
        failed: 'Não foi possível atualizar as reservas. Utilize «Sincronizar da Loja Online» no separador Reservas.',
      },
      storefront: {
        not_set_up: 'A Loja não foi atualizada: não foi encontrada nenhuma loja para esta localização.',
        not_matched:
          'A Loja não foi atualizada: o horário {{time}} não existe lá. Verifique os horários no separador Loja.',
        failed: 'Não foi possível atualizar a Loja. Utilize «Sincronizar da Loja Online» no separador Loja.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Fuso horário',
        },
      },
      toasts: {
        error: 'Falha ao atualizar o fuso horário',
      },
    },
  },
};
